export default __webpack_public_path__ + "static/media/PayoutActive.750dc750.svg";